import { useState } from "react";
import { toast } from "react-toastify";
import { exportToCSV, formatCSVData } from "@utils/export";
import { formatDateTime, actualDateTime } from "@utils/formatters";
import { LOCATIONS_EXPORT_HEADS } from "@typings/entities/location/export";
import { exportLocations } from "@services/location/export";

export function useExportLocations() {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async () => {
    setIsLoading(true);
    try {
      const response = await exportLocations();

      if (!response.items?.length) {
        toast.warning("Nenhum local disponível para exportar");
        return;
      }

      const translatedData = response.items.map((item) => ({
        ...item,
        latitude: item.latitude ?? "",
        longitude: item.longitude ?? "",
        responsible: item.responsible ?? "",
        email: item.email ?? "",
        createdAt: formatDateTime(item.createdAt),
        updatedAt: formatDateTime(item.updatedAt),
      }));

      const formattedData = formatCSVData(
        translatedData,
        LOCATIONS_EXPORT_HEADS,
      );
      exportToCSV(formattedData, `relatorio_locais_${actualDateTime()}`);
      toast.success("Relatório de locais exportado com sucesso!");
    } catch {
      toast.error("Erro ao exportar relatório de locais");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
